<template>
	<article class="card pub-preview">
		<header class="card-header border-bottom-0 pub-preview__header">
			<div class="header-body">
				<div class="text-secondary font-weight-light pub-preview__meta pub-preview__meta--doi mb-3">{{ citation }}</div>
				<h1 class="card-header-title pub-preview__title">
					<router-link :to="detailLink" class="pub-preview__link">{{ title }}</router-link>
				</h1>
			</div>
		</header>
		<main class="card-body pub-preview__body lead">
			<div class="pub-preview__author-wrap text-secondary mb-3">
				<span class="pub-preview__author-icon fe fe-users mr-2"></span>
				<span class="pub-preview__meta pub-preview__meta--authors">{{ authors }}</span>
			</div>
			<div v-if="readMore" class="pub-preview__abstract" v-html="abstract"></div>
			<div v-if="!readMore" class="pub-preview__abstract--developed">{{ abstractTruncated }}</div>
			<b-button class="pub-preview__abstract__more" size="lg" @click="readMoreClick">{{ readMoreText }}</b-button>
		</main>
		<footer class="card-footer border-top-0 pub-preview__footer d-flex">
			<div class="text-secondary font-weight-light pub-preview__meta pub-preview__meta--journal">{{ doi }}</div>
			<div class="text-secondary font-weight-light pub-preview__meta pub-preview__meta--year">{{ year }}</div>
		</footer>
	</article>
</template>

<script>
export default {
	name: 'PublicationCard',
	computed: {
		detailLink () {
			return `/publication/${this.code}`
		},
		abstractTruncated () {
			let regex = /(<([^>]+)>)/ig;
			// strip html tags, truncate at 50 words and add an ellipsis character at the end
			return this.abstract.replace(regex, " ").split(" ").splice(0, 50).join(" ").concat('…');
		}
	},
	data () {
		return {
			readMore: false,
			readMoreText: "More"
		}
	},
	methods: {
		readMoreClick () {
			this.readMore = !this.readMore;
			this.readMoreText = this.readMore ? "Less" : "More";
		}
	},
	props: {
		code: String,
		doi: String,
		title:  String,
		authors:  String,
		journal:  String,
		year: String,
		abstract: String,
		citation: String
	}
}
</script>

<style scoped lang="scss">
.pub-preview {
	transition: box-shadow .3s ease-out;

	&__meta {
		letter-spacing: 1.2px;

		&--year {
			// @include media-breakpoint-up(sm) {
				// border-left: 1px solid;
				// margin-left: .75rem;
				// padding-left: .75rem;

			// }
		}
	}

	&__title {
		font-size: 1.5rem;
		letter-spacing: 0.5px;
		line-height: 1.4;
	}

	&__footer {
		display: flex;
		justify-content: space-between;
		align-items: flex-end;

		// @include media-breakpoint-up(sm) {
			// justify-content: flex-end;
		// }
	}

	&__link {
		color: inherit;
		transition: color .2s ease-out;

		&::after {
			content: "";
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			z-index: 1;
			display: block;
		}
	}

	&__abstract__more {
		background-color: #f6f6f6;
		color: #1f2a40;
		border-color: #f6f6f6;
		transition: all .2s ease-out;
		margin-top: 1rem;
		position: relative;
		z-index: 3;

		&:hover {
			border-color: #f6f6f6;
			background-color: #c6c6c6;
		}

		&:focus,
		&:active {
			background-color: #1f2a40 !important;
			border-color: #1f2a40 !important;
			color: #ffffff !important;
		}
	}

	/**
	 * States
	 */
	&:hover {
		box-shadow: 0 1rem 1.5rem transparentize(black, .9)
	}
}
</style>
